const persistStoreFields = (store, config) => {
  const syncValue = ({ name, select, convert = x => x }) => {
    const state = store.getState();
    const storeValue = select(state);
    if (storeValue === undefined) return;
    const updateStorageValue = () => localStorage.setItem(name, storeValue);

    const storageValueString = localStorage.getItem(name);
    if (storageValueString) {
      const storageValue = convert(storageValueString);
      if (storageValue !== storeValue) updateStorageValue();
    } else updateStorageValue();
  }

  store.subscribe(() => {
    config.forEach(syncValue);
  });
}

export default persistStoreFields;
